// extracted by mini-css-extract-plugin
export var completionBody = "_bv-2";
export var completionCard = "_bv-0";
export var completionFooter = "_bv-3";
export var completionTitle = "_bv-1";